import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import moment from 'moment';
import { BsFiletypeCsv } from "react-icons/bs";
import { SiMicrosoftexcel } from "react-icons/si";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import { toast } from 'react-toastify';
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useCurrency } from '../../Layouts/currencyContext';
import * as XLSX from "xlsx";
import Table from 'react-bootstrap/Table';
import { Fragment } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import AsyncSelect from 'react-select/async';
import { BarLoader, ClipLoader } from 'react-spinners';

const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
const StockMovement = () => {
    const apiService = new ApiService();
    const [rowData, setRowData] = useState([]);
    const [allData, setallData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [StockType, setStockType] = useState();
    const { currencyPrecision } = useCurrency();
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [searchLoader, setSearchLoader] = useState(false);
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const [formData, setFormData] = useState({
        fromDate: '',
        toDate: '',
        itemNo: [{ label: 'Select Item no', value: '0' }],
        ItemDescription: [{ label: 'Select Item Description', value: '0' }],
        category: [{ label: 'Select Item Category', value: '0' }],
        warehouse: [{ label: 'Select Warehouse', value: '0' }],
    });

    const handleClearFilters = () => {
        const today = new Date();
        setFormData({
            fromDate: formatDate(today),
            toDate: formatDate(today),
            itemNo: [{ label: 'Select Item no', value: '0' }],
            ItemDescription: [{ label: 'Select Item Description', value: '0' }],
            category: [{ label: 'Select Item Category', value: '0' }],
            warehouse: [{ label: 'Select Warehouse', value: '0' }],
        });
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {

                const today = new Date();

                setFormData((prev) => ({
                    ...prev,
                    fromDate: formatDate(today),
                    toDate: formatDate(today),
                }));

                const categoryResponse = await apiService.get('GET_CATEGORY');
                setCategoryOptions(categoryResponse?.data?.result);

                const warehouseResponse = await apiService.get('GET_WAREHOUSE_MASTER');
                setWarehouseOptions(warehouseResponse?.data?.result);

            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
    }, []);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    }
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    }
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    }
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    }
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    }
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === 'itemNo' || name === 'ItemDescription') {
            setFormData({
                ...formData,
                itemNo: value ? { label: value.value.itemNo, value: value.value } : null,
                ItemDescription: value ? { label: value.value.itemDescription, value: value.value } : null,
            });
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleShow = () => {
        {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: 'StockMovement' },
                    { name: 'FromDate', value: formData?.fromDate || '' },
                    { name: 'toDate', value: formData?.toDate || '' },
                    { name: 'Warehouse', value: formData.warehouse?.label || '' },
                    { name: 'Category', value: formData.category?.value?.catCode || '' },
                    { name: 'ItemNo', value: formData.itemNo?.label || '' },
                ];

                debugger
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className='p-4'>
            <div className='gridBg m-0' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='pb-2 row'>
                    <div className='col'>
                        <AsyncSelect
                            cacheOptions
                            value={formData.itemNo}
                            options={itemOptions}
                            loadOptions={loadOptions}
                            isClearable
                            onChange={(selectedOption) => handleDropDownChange({ name: 'itemNo', value: selectedOption })}
                            defaultOptions={itemOptions}
                            onMenuScrollToBottom={loadMoreOptions}
                            noOptionsMessage={({ inputValue }) =>
                                inputValue.length < 3
                                    ? "Type at least 3 characters..."
                                    : "No records found"
                            }
                        />
                    </div>
                    <div className="col d-flex justify-content-between start ">
                        <DatePicker
                            selected={formData.fromDate}
                            // disabled={!dateFilter}
                            onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                            className="p-2 form-Input w-100"
                            dateFormat="dd-MM-yyyy"
                        />
                    </div>
                    <div className="col">
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.warehouse}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'warehouse', value: selectedOption })}
                            options={warehouseOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.description }))}
                        />
                    </div>
                    <div className='col'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100' type="button"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={handleShow} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Show</div>
                            </div>
                        }
                    </div>
                </div>
                <div className='pb-2 row'>
                    <div className='col'>
                        <AsyncSelect
                            cacheOptions
                            value={formData.ItemDescription}
                            isClearable
                            options={descriptionOptions}
                            loadOptions={loadDescOptions}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'ItemDescription', value: selectedOption })}
                            className="w-100 p-0"
                            defaultOptions={descriptionOptions}
                            onMenuScrollToBottom={loadMoreDescOptions}
                            noOptionsMessage={({ inputValue }) =>
                                inputValue.length < 3
                                    ? "Type at least 3 characters..."
                                    : "No records found"
                            }
                        />
                    </div>
                    <div className="col d-flex justify-content-between start ">
                        <DatePicker
                            selected={formData.toDate}
                            onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                            className="p-2 form-Input w-100"
                            // disabled={!dateFilter}

                            dateFormat="dd-MM-yyyy"
                        />
                    </div>
                    <div className='col'>
                        <Select
                            className="p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData.category}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
                            options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                        />
                    </div>
                    <div className='col'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Stock Movement Report</div>
            </div>
            <div className='gridshad'>
                {loading === true ?
                    <div className="center p-5">
                        <BarLoader color="#6E5199" height={3} width={200} />
                    </div>
                    :
                    <Table bordered hover responsive className="custom-table shadow-sm">
                        <thead className="table-header">
                            <tr>
                                <th className="text-center">Supplier</th>
                                <th >Requisition No</th>
                                <th>Requisition Date</th>
                                <th className="text-end">PO No</th>
                                <th>PO Date</th>
                                <th>PO Amount</th>
                                <th className="text-start">GRN No</th>
                            </tr>
                        </thead>
                    </Table>

                }
            </div>
        </div>
    );
};
export default StockMovement;